import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { FeaturePageStructuredData } from "../../config/StructuredData";

const FYPeriodTracking = () => (
  <>
    <FeaturePageStructuredData
      name="FY and Period-Based Workflow Tracking"
      description="Simplifyte lets CA firms and professional teams track work by financial year, quarter, and period — so no client filing or period is ever missed or duplicated."
      url="https://www.simplifyte.com/features/fy-period-tracking"
    />
    <HeaderMenu />
    <main style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <section style={{ background: "linear-gradient(135deg,#093A5B 0%,#0a4d6e 100%)", padding: "60px 24px", color: "#fff", textAlign: "center" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <p style={{ fontSize: "13px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.7, marginBottom: "16px" }}>Features</p>
          <h1 style={{ fontSize: "clamp(26px,4vw,44px)", fontWeight: 700, lineHeight: 1.2, marginBottom: "20px" }}>FY and Period-Based Workflow Tracking</h1>
          <p style={{ fontSize: "17px", opacity: 0.85, maxWidth: "640px", margin: "0 auto 32px" }}>Every piece of work tagged to a financial year and period — so AY 2025-26 Q1 GST returns are never confused with AY 2024-25.</p>
          <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>Book a Demo</Link>
        </div>
      </section>

      <section style={{ padding: "60px 24px" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "26px", fontWeight: 700, color: "#093A5B", marginBottom: "16px" }}>Why FY and period tracking matters for CA firms</h2>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7, marginBottom: "16px" }}>
            CA firms and tax consultants handle the same work for the same clients every year — ITR for AY 2025-26, GSTR-3B for April 2025, TDS for Q1 FY 2025-26. Without period-aware tracking, teams duplicate work, miss periods, or confuse one year's filing with another.
          </p>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7 }}>
            Simplifyte builds financial year and period natively into every work item — not as a label but as a first-class field that drives visibility, reminders, and reporting.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: "16px", marginTop: "32px" }}>
            {["Tag work to AY, FY, quarter, or month","Filter all pending work for a specific period","Avoid duplicate work across periods","Period-based reporting for partner review","Recurring work templates per period"].map((t,i)=>(
              <div key={i} style={{ background: "#f8fafc", padding: "16px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px", color: "#475569" }}>✓ {t}</div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "40px 24px", background: "#f8fafc" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#093A5B", marginBottom: "24px" }}>Before Simplifyte / With Simplifyte</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div style={{ background: "#fff5f5", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#ef4444", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>Before Simplifyte</h3>
              {["Period tracked in column headers in Excel","Easy to accidentally file for wrong AY","No way to quickly see all Q1 FY 26 pending work","Year-end scramble to identify what was missed","Manual reconciliation to check period coverage"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #fca5a5" }}>{t}</p>))}
            </div>
            <div style={{ background: "#f0fdf4", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#16a34a", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>With Simplifyte</h3>
              {["FY and period are fields on every work item","Filter open work by AY 2025-26 in one click","Period dashboard shows coverage at a glance","Recurring period tasks auto-created","No confusion between clients' different periods"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #86efac" }}>{t}</p>))}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px", textAlign: "center", background: "#093A5B", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: 700, marginBottom: "14px" }}>Never miss a period's work again</h2>
        <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "13px 30px", borderRadius: "8px", fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "8px" }}>Book a Demo <ArrowRight size={16} /></Link>
      </section>
    </main>
    <CustomFooter />
  </>
);

export default FYPeriodTracking;
